module.exports = __webpack_public_path__ + "img/closeBlack.330a24cb.svg";